/**
 * Admin 认证服务
 * 管理 Admin JWT access/refresh token 的存储、刷新和注销
 */
import axios from 'axios';
import { config } from '../config';

const BASE = config.API_BASE_URL;

const KEYS = {
  access: 'admin_access_token',
  refresh: 'admin_refresh_token',
};

export const adminAuthService = {
  // ── 存储 ──────────────────────────────────────────────
  getAccessToken: () => localStorage.getItem(KEYS.access),
  getRefreshToken: () => localStorage.getItem(KEYS.refresh),

  _save(access, refresh) {
    localStorage.setItem(KEYS.access, access);
    if (refresh) localStorage.setItem(KEYS.refresh, refresh);
  },

  clear() {
    localStorage.removeItem(KEYS.access);
    localStorage.removeItem(KEYS.refresh);
  },

  isLoggedIn() {
    return !!this.getAccessToken();
  },

  // ── 登录 ──────────────────────────────────────────────
  async login(username, password) {
    const res = await axios.post(`${BASE}/auth/admin/login`, { username, password });
    this._save(res.data.access_token, res.data.refresh_token);
    return res.data;
  },

  // ── 刷新 access token ─────────────────────────────────
  async refresh() {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) throw new Error('No refresh token');
    const res = await axios.post(`${BASE}/auth/admin/refresh`, { refresh_token: refreshToken });
    localStorage.setItem(KEYS.access, res.data.access_token);
    return res.data.access_token;
  },

  // ── 注销 ──────────────────────────────────────────────
  async logout() {
    const refreshToken = this.getRefreshToken();
    if (refreshToken) {
      try {
        await axios.post(`${BASE}/auth/admin/logout`, { refresh_token: refreshToken });
      } catch (_) { /* ignore */ }
    }
    this.clear();
  },
};

export default adminAuthService;
